var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgConnector6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.68,3.41a10.87,10.87,0,0,1,9.51,5.5l4.18,7.23,4.18,7.24A11,11,0,0,1,50,39.86H33.32a11,11,0,0,1-9.51-16.48L28,16.14l4.18-7.23a10.87,10.87,0,0,1,9.51-5.5m0-3a13.84,13.84,0,0,0-12.11,7l-4.18,7.23-4.18,7.24a14,14,0,0,0,12.11,21H50a14,14,0,0,0,12.11-21L58,14.64,53.79,7.41a13.84,13.84,0,0,0-12.11-7Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.51,63.59a9.85,9.85,0,0,1-5.16-1.34,6.12,6.12,0,0,1-2.85-6.41c.93-3.33.77-5.68-.41-7a5.27,5.27,0,0,0-3.53-1.4H2.21a2,2,0,1,1,0-4H22.49a10,10,0,0,1,7.11,2.9c2.13,2.37,2.58,5.83,1.32,10.28a2.17,2.17,0,0,0,1,2.35,6.23,6.23,0,0,0,5.42,0,3.06,3.06,0,0,0,2.06-2.69v-14a2.26,2.26,0,0,1,4.5,0v14c0,2.66-1.64,4.94-4.49,6.26A11.86,11.86,0,0,1,34.51,63.59Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.68,20.22a5.93,5.93,0,1,1,5.93-5.93A5.94,5.94,0,0,1,41.68,20.22Zm0-9.86a3.93,3.93,0,1,0,3.93,3.93A3.93,3.93,0,0,0,41.68,10.36Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.33,35.14A4.62,4.62,0,1,1,56,30.52,4.63,4.63,0,0,1,51.33,35.14Zm0-7.74a3.12,3.12,0,1,0,3.12,3.12A3.12,3.12,0,0,0,51.33,27.4Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,35.14a4.62,4.62,0,1,1,4.62-4.62A4.62,4.62,0,0,1,32,35.14Zm0-7.74a3.12,3.12,0,1,0,3.12,3.12A3.12,3.12,0,0,0,32,27.4Z",
    fill: "#231f20"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgConnector6);
export default __webpack_public_path__ + "static/media/img_connector_6.560849731b3dd267ace8a82a1eddf495.svg";
export { ForwardRef as ReactComponent };